import {
  ISalesSubCategoryModel,
  SalesSubCategoryModel,
} from '@common/models/SalesSubCategoryModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceMethodOptions } from '@common/services';

export class SalesSubCategoryService {
  private static baseUrl: string = '/api/salessubcategory';

  static tags = {
    getSalesSubCategories: 'getSalesSubCategories',
    getSalesSubCategory: 'getSalesSubCategory',
    updateSalesSubCategory: 'updateSalesSubCategory',
    deleteSalesSubCategory: 'deleteSalesSubCategory',
  };

  static getSalesSubCategories = (
    options?: ServiceMethodOptions,
  ): Promise<SalesSubCategoryModel[]> => {
    return trackPromise(
      new Promise<ISalesSubCategoryModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/listing`)
          .get<ISalesSubCategoryModel[]>()
          .then((response) => response.map((d) => new SalesSubCategoryModel(d)))
          .then(resolve)
          .catch((err) => reject(err));
      }),
      this.tags.getSalesSubCategories,
    );
  };

  static getSalesSubCategory = (
    salesSubCategoryId: number,
    options?: ServiceMethodOptions,
  ): Promise<SalesSubCategoryModel> => {
    return trackPromise(
      new Promise<ISalesSubCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}/${salesSubCategoryId}`)
          .get<ISalesSubCategoryModel>()
          .then((response) => new SalesSubCategoryModel(response))
          .then(resolve)
          .catch((err) => reject(err));
      }),
      this.tags.getSalesSubCategories,
    );
  };

  static upsertSalesSubCategory = (
    data: ISalesSubCategoryModel,
    options?: ServiceMethodOptions,
  ): Promise<SalesSubCategoryModel> => {
    return trackPromise(
      new Promise<ISalesSubCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ISalesSubCategoryModel>(data)
          .then((response) => new SalesSubCategoryModel(response))
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.updateSalesSubCategory,
    );
  };

  static deleteSalesSubCategory = (
    SalesSubCategoryId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${SalesSubCategoryId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.deleteSalesSubCategory,
    );
  };
}
